export enum Actions {
    SetPageLoading,
    UpdateIsBusy,
    MoveNext,
    MoveBack,
    SelectLocation,
    UpdateServices,
    SelectService,
    SelectServiceCategory,
    SelectProvider,
    UpdateLocations,
    UpdateProviders,
    UpdateAvailability,
    SelectDate,
    SelectSlotProvider,
    SelectSlot,
    NavigateMonthBefore,
    NavigateMonthNext,
    UpdateIsUserLoggedIn,
    UpdateLoggedInClient,
    UpdateShowNotes,
    UpdateShowStripe,
    SetIdempotencyKey,
    UpdateClients,
    SelectClient,
    UpdateBookedAppointment,
    RequestCancel,
    SetStep,
    UpdateCreditCard,
    EditCreditCard,
    ApplyClientDiscount,
    ApplyDeposit,
    ApplyFullPayment,
    ApplyTax,
    FlushSteps,
    FlushAvailability,
    SelectGroup,
    UpdateService,
    ApplyAmountStripeFee,
    ApplyTotalAmountStripeFee,
}
